module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "pg30lev1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Razor clams with crispy rice and hot sauce",
      "src": "images/f0030-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("On the Princes’ Islands in Turkey, seafood is a staple. "), _c('em', [_vm._v("Midye dolma")]), _vm._v("—mussels stuffed with rice, pine nuts, currants, and spices—are sold on the beachfront, and they served as the inspiration for this little mezze of mine. “Mezze” means taste, flavor, snack, or relish, which is how these are intended to be offered—as tastes, alongside other little dishes. But don’t think you have to make lots of complicated dishes for a successful spread; simply using one main ingredient and varying it with some sides or garnishes is a less fussy solution. This stuffed-clam recipe pairs perfectly with Razor Clams with Tzatziki and Pomegranate "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter08#pg29lev1"
    }
  }, [_vm._v("(page 29)")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0031-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Serves 4 as a canap"), _c('span', {
    staticClass: "display_type"
  }, [_vm._v("é")]), _vm._v(" or starter")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Preparation time: 30 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Cooking time: 30 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("8 razor clams")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("2 tbsp olive oil, plus more for drizzling")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 small onion, peeled and finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("4 cloves of garlic, peeled and finely minced")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("8 cherry tomatoes, roughly chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 small red chile, seeded and finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tbsp red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" cup cooked brown rice")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 small red Romano pepper, seeded and finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tbsp dried mint")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("2 sprigs of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Heat a grill.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Bring a large saucepan of water to a boil. Set up a large bowl of iced water nearby. Drop 4 razor clams into the boiling water, then fish them out almost immediately with a pair of tongs and drop them straight into the iced water. They should open but not cook. Repeat with the remaining clams.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Pull the clams out of their shells and use a pair of scissors to cut the black sack out of the clam, remove the “beak,” then chop the clams into thumbnail-size pieces. Put the clams into a bowl. Wash and dry 8 half-shells and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Put 1 tbsp of the oil into a large nonstick frying pan over medium heat. Add the onion, garlic, tomatoes, and chile and fry for about 15 minutes, or until the tomatoes and onion are soft but not brown. Transfer the tomato mixture to a quart-size liquid measuring cup and, using an immersion blender, blend into a smooth paste. Stir in the vinegar.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Wipe out the frying pan and place over medium heat. Add the remaining 1 tbsp oil. Add the brown rice and fry for about 10 minutes, or until golden and crisp. Add the clams for the last couple of minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Spread some of the sauce on the bottom of a half-shell, followed by some of the crispy rice and clams and Romano pepper pieces. Sprinkle with the dried mint and parsley and drizzle with olive oil. Repeat with the remaining half-shells, and serve.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e605c5ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/15-chapter09.vue
// module id = 99
// module chunks = 0